module.exports = __webpack_public_path__ + "img/room.615ccd72.png";